module.exports = __webpack_public_path__ + "img/website-03.d495f549.png";